import orderTranslationsHelper from "../../../../languages/order-translations.helper";
import {
  OrderJoinAssignedToDriverError,
  OrderJoinChangeRideRelatedError,
  OrderJoinChangeTargetRideErrorType,
  OrderJoinErrorType,
} from "./order-join-error";

const createNodeAlreadyCheckedOutError =
  (): OrderJoinChangeRideRelatedError => {
    const translations = orderTranslationsHelper.getOrderJoinTranslations();

    return {
      type: OrderJoinErrorType.CHANGE_RIDE_RELATED,
      params: {
        changeTargetRideError: {
          errorType:
            OrderJoinChangeTargetRideErrorType.NODE_ALREADY_CHECKED_OUT,
        },
      },
      message: translations.notAcceptableNodeCheckedOutErrorMessageText,
    };
  };

const createNoValidContractError = (): OrderJoinChangeRideRelatedError => {
  const translations = orderTranslationsHelper.getOrderJoinTranslations();

  return {
    type: OrderJoinErrorType.CHANGE_RIDE_RELATED,
    params: {
      changeTargetRideError: {
        errorType:
          OrderJoinChangeTargetRideErrorType.NO_VALID_CARGO_RAILY_CONTRACT ||
          OrderJoinChangeTargetRideErrorType.NO_VALID_CARGO_TAXI_CONTRACT,
      },
    },
    message: translations.notAcceptableNoValidContractErrorMessageText,
  };
};

const createNoRelevantDispatchError = (): OrderJoinChangeRideRelatedError => {
  const translations = orderTranslationsHelper.getOrderJoinTranslations();

  return {
    type: OrderJoinErrorType.CHANGE_RIDE_RELATED,
    params: {
      changeTargetRideError: {
        errorType:
          OrderJoinChangeTargetRideErrorType.NO_RELEVANT_DISPATCH_FOUND,
      },
    },
    message: translations.notAcceptableNoRelevantDispatchErrorMessageText,
  };
};

const createDefaultError = (): OrderJoinChangeRideRelatedError => {
  const translations = orderTranslationsHelper.getOrderJoinTranslations();

  return {
    type: OrderJoinErrorType.CHANGE_RIDE_RELATED,
    params: {
      changeTargetRideError: {
        errorType: OrderJoinChangeTargetRideErrorType.DEFAULT,
      },
    },
    message: translations.notAcceptableOtherErrorMessageText,
  };
};

const createOrderAssignedToDriverError = (): OrderJoinAssignedToDriverError => {
  const translations = orderTranslationsHelper.getOrderJoinTranslations();

  return {
    type: OrderJoinErrorType.ORDER_ASSIGNED_TO_DRIVER,
    message: translations.notAcceptableOrderAssignedToDriverErrorMessageText,
    params: {},
  };
};

const orderJoinErrorFactory = {
  createNodeAlreadyCheckedOutError,
  createNoValidContractError,
  createNoRelevantDispatchError,
  createOrderAssignedToDriverError,
  createDefaultError,
};

export default orderJoinErrorFactory;
